import { connect } from 'react-redux'

import SalesChannelModal from '../../../pages/settings/components/Modals/CanalModal'

import {
  assignToChannel,
  fetchKeys,
  fetchSalesChannels,
  fetchSalesChannelsMore,
  getKeysMore,
  onSearchKeys,
  pageChangedKeys,
  resetConfig,
} from '../../../redux/configuration/actions'
import {
  getConfigSuccess,
  getErrorMessageConfig,
  getIsLoadingAssign,
  getIsLoadingSalesChannelList,
  getKeys,
  getKeysCount,
  getKeysListIsLoading,
  getSalesChannelList,
  getSalesChannelListCount,
} from '../../../redux/configuration/selectors'

const mapStateToProps = (state) => ({
  salesChannelList: getSalesChannelList(state),
  isLoadingSalesChannelList: getIsLoadingSalesChannelList(state),
  salesChannelListCount: getSalesChannelListCount(state),
  keys: getKeys(state),
  isLoadingKeysList: getKeysListIsLoading(state),
  keysCount: getKeysCount(state),

  isLoadingAssign: getIsLoadingAssign(state),
  success: getConfigSuccess(state),
  errorMessage: getErrorMessageConfig(state),
})

const mapDisptachToProps = (dispatch) => ({
  getSalesChannels: (filter) => dispatch(fetchSalesChannels(filter)),
  getSalesChannelsMore: (filter) => dispatch(fetchSalesChannelsMore(filter)),

  fetchKeys: () => dispatch(fetchKeys()),
  searchKeys: (search) => {
    dispatch(onSearchKeys(search))
    dispatch(pageChangedKeys(0))
    dispatch(fetchKeys())
  },
  fetchMoreKeys: (offset) => {
    dispatch(pageChangedKeys(offset))
    dispatch(getKeysMore())
  },
  resetConfig: () => dispatch(resetConfig()),

  assign: (data) => dispatch(assignToChannel(data)),
})

export default connect(mapStateToProps, mapDisptachToProps)(SalesChannelModal)
